import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const getFeatureFlags = async () => {
  try {
    const url = "v1/servicedesk/feature-flags";
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const setFeatureFlagsAsSeen = async (feature: string) => {
  try {
    const url = `v1/servicedesk/feature-flags/seen/${feature}`;
    const response = await axiosClient.patch(url);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const setMspFeatureFlagsAsSeen = async (feature: string) => {
  try {
    const url = `/v1/servicedesk/msp/feature-flags/seen/${feature}`;
    const response = await axiosClient.patch(url);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
